import React from 'react'
import { Link } from 'react-router-dom'
import ErrorMessageUI from '../../../widgets/form/ErrorMessageUI'
import SuTransactionInnerListUI from './SuTransactionInnerListUI'
import TransactionTypeChangeModalSF from './TransactionTypeChangeModalSF'

const SuTransactionListUI = ({ context, txnList, bankAccountNumber, onRefreshClick,
  details, onDetailsClick, onCopyToClipboard, copyToClipboardText,
  onNachFileUploadClick, nachFileUploadErrorList, account,
  onUploadTraditionalEscrowClick, uploadTraditionalEscrowErrorList,
  totalCount, pageSize, currentPage, onPreviousPage, hasMore, onNextPage,
  transactionTypeUpdated, onTransactionTypeUpdateClick, onTransactionTypeCancelClick, selectedTransactionId
}) =>
  <div className='txns'>
    <div className='g_flex_h g_flex_right'>
      <span className='g_muted'><i>Search by payee/payer, narration, type</i></span>
    </div>


    <div className='g_flex_h g_m_top_25 g_m_bottom_25'>
      <Link to='#' onClick={onDetailsClick}>Details</Link>
      {
        context.permissions.includes('su_superuser_business') &&
        <>
          <Link to='#' onClick={onNachFileUploadClick}>Upload NACH Excel file</Link>
          <ErrorMessageUI errorList={nachFileUploadErrorList}></ErrorMessageUI>
          <Link to='#' onClick={onUploadTraditionalEscrowClick}>Upload collection account CSV file</Link>
          <ErrorMessageUI errorList={uploadTraditionalEscrowErrorList}></ErrorMessageUI>
        </>
      }
    </div>
    {
      txnList && txnList.length > 0 && (
        <SuTransactionInnerListUI context={context} details={details} txnList={txnList}
          onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
          onTransactionTypeUpdateClick={onTransactionTypeUpdateClick} account={account}
        />
      )
    }
    {txnList && totalCount > pageSize && (
      <div className="g_flex_h g_flex_center g_m_top_20">
        <button
          className="btn_secondary"
          disabled={currentPage === 1}
          onClick={onPreviousPage}
        >
          Previous
        </button>

        <span className="g_m_lr_15">
          Page {currentPage} of {Math.ceil(totalCount / pageSize)}
        </span>

        <button
          className="btn_primary"
          disabled={!hasMore}
          onClick={onNextPage}
        >
          Next
        </button>
      </div>
    )}

    <TransactionTypeChangeModalSF
      context={context} bankAccountNumber={bankAccountNumber}
      selectedTransactionId={selectedTransactionId}
      updateMode={transactionTypeUpdated}
      onCancelClick={onTransactionTypeCancelClick}
      onRefreshClick={onRefreshClick}
    />
  </div>

export default SuTransactionListUI
